import Categories from '@/content/faqs/categories.json';

export default class FaqCategories {
    categories = []

    constructor() {
        this.categories = Categories.items;
    }

    handle() {
        return new Promise((resolve) => { resolve(this.categories); });
    }

    findCategoryByPath(path) {
        path = path.replace(/(\/faq\/[^/]+).*/, '$1');

        return new Promise((resolve) => {
            resolve(this.categories
                .filter((current) => path === current.path)[0],
            );
        });
    }
}
